import React from 'react';
import { Modal } from 'react-bootstrap';
let AlertComponent = ({ show, message, hide }) => {
    return (<Modal show={show} onHide={() => hide()} className="alertDialog">
        <Modal.Body>
            <h1>{message}</h1>
        </Modal.Body>
    </Modal>);
}

export default AlertComponent